/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Lockout {
    export class LockoutController {

        private userName: any;
        private password: any;
        private status: string = null;
        private ipRestrictedmessage: string = null;

        public formMode: string = 'login';
        public mfaCode: string;
        public rememberDevice = false;
        private mfaJwt: string; 

        static $inject = [
            "$rootScope",
            "$window",
            "$mdDialog",
            "meevo.components.common.IdentityService",
            "meevo.components.common.DataService",
            "$translate",
            "caller",
            "meevo.components.modal.ModalService",
            "meevo.components.busy.BusyService",
            "meevo.AppSettings",
            "$http"
        ];

        constructor(private $rootScope: ng.IRootScopeService,
            private $window: angular.IWindowService,
            private $mdDialog: angular.material.IDialogService,
            private identityService: Meevo.Components.Common.IdentityService,
            private dataService: Meevo.Components.Common.ICommonDataService,
            private $translate: angular.translate.ITranslateService,
            private caller: string,
            private modalService: Meevo.Components.Modal.IModalService,
            private busyService: Meevo.Components.Busy.IBusyService,
            private appSettings: Components.Common.IAppSettings,
            private $http: angular.IHttpService) {

            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLEAR_SESSION_TIMEOUT, (event: angular.IAngularEvent) => { });
            this.identityService.current().isAuthenticated = false;
            this.userName = this.identityService.current().userAuthName;
            this.formMode = "login";

        }

        login() {
            if (this.formMode === "mfa") {
                return;
            }

            //Security/AppAuth  -> AuthLogic.cs LoginAsync
            let url = `/api/auth/credentials?tenantId=${this.identityService.current().tenantId}`
            let account: any = {
                username: this.userName,
                password: this.password
            }

            const mfaRememberToken = localStorage.getItem(`mil:meevo:remember:${this.userName.toLowerCase()}`);
            if (mfaRememberToken) {
                account.mfaRememberToken = mfaRememberToken;
            }

            this.dataService.login(account)
                .then((res) => {
                    if (res.responseStatus && res.responseStatus.errorCode === 'MFA_REQUIRED') {
                        this.formMode = 'mfa';
                        this.mfaJwt = res.bearerToken;
                        return;
                    }

                    this.finishLogin(res);

                })
                .catch((res) => {
                    this.status = res.data.responseStatus;
                });

        }

        finishLogin(res) {
            if (res.bearerToken) {
                this.identityService.setToken(res.bearerToken);
            }
            // no emulation was active when screen was locked
            if (!this.identityService.isEmulating) {
                return this.dataService.getIdentityFull().then((data: Meevo.Components.Common.IIdentity) => {
                    if (this.identityService.loggedInUserId() !== res.userId) {
                        this.$rootScope.$broadcast(Meevo.Components.Common.Messages.FORCE_SESSION_RELOAD);
                    }
                    this.status = "";
                    this.identityService.setIdentity(data);                
                    this.$rootScope.$broadcast(Meevo.Components.Common.Messages.REFRESH_IDENTITY, true);
                    this.logout(false);
                });
            }

            const identityData = this.identityService.emulationData;

            // Emulation was active when screen was locked, but a different user logged in
            if (this.identityService.loggedInUserId() !== res.userId) {
                let options = {
                    templateUrl: "app/components/modal/modal.template.html",
                    controller: "meevo.plugins.callCenter.CallCenterSyncModalController",
                    controllerAs: "vm",
                    bindToController: true,
                    locals: { isRelockAvailable: true }
                }

                this.modalService.showCustom(options);

                return;
            }

            // emulation was active, and the same user logged back in
            this.$rootScope.$broadcast(Components.Common.Messages.CALL_CENTER_EMULATION_CHANGE, { skipClosingTabs: true, emulationData: identityData });
            this.logout(false);
        }

        logout(redirect: boolean) {
            if (!redirect)
                return this.$mdDialog.hide(redirect);

            this.$window.onbeforeunload = () => null;
            this.$window.location.href = this.identityService.current().sessionTimeoutRedirectUrl;
        }

        goToLogin() {
            this.formMode = 'login';
        }

        toggleRemember() {
            this.rememberDevice = !this.rememberDevice;
        }

        submitMfa() {
            this.busyService.start();
            const code = this.mfaCode ? this.mfaCode.replace(/[-\s]/g, "") : this.mfaCode;
            const remember = this.rememberDevice;
            let url = `/api/auth/mfa/verify/${code}`;
            if (remember) {
                url += '?remember=true'
            }
            this.$http.get(url, {
                withCredentials: true, headers: {
                    "Content-Type": "application/json",
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${this.mfaJwt}`,
                }
            }).then((resp: any) => {
                this.busyService.stop();
                var data = resp.data;
                if (data.mfaRememberToken) {
                    localStorage.setItem(`mil:meevo:remember:${this.userName.toLowerCase()}`, data.mfaRememberToken);
                }
                if (data.bearerToken) {
                    this.identityService.setToken(data.bearerToken);
                }

                let locationId = { 'locationId': this.identityService.current().locationId };
                this.dataService.patch(this.appSettings.API_ENDPOINTS.session, locationId).then(data => {
                    this.finishLogin(data);
                })
            })
                .catch(() => {
                    this.busyService.stop();
                    this.status = 'Invalid or expired code.';
                });

        };


    }

    angular.module("meevo")
        .controller("meevo.lockout.LockoutController", LockoutController);
}